// import logo from "../Assets/Images/logo.png";
import logo from "../Assets/Images/inkjet-white.png";
import home from "../Assets/Images/home.svg";
import notification from "../Assets/Images/notification.svg";
import bitCoin from "../Assets/Images/bit-coin.svg";
import application from "../Assets/Images/application.svg";
import downarrowDark from "../Assets/Images/downarrowdark.svg";
import etheImg from "../Assets/Images/ethereumcoin.svg";
import breadcrumb from "../Assets/Images/Breadcrumb.svg";
import arrow from "../Assets/Images/arrow.svg";
import exchange from "../Assets/Images/Exchange.svg";
import history from "../Assets/Images/history.svg";
import masterCard from "../Assets/Images/master-card.svg";
import backArrow from "../Assets/Images/back-Arrow.svg";
import binance from "../Assets/Images/binancecoin.svg";
import tron from "../Assets/Images/troncoin.svg";
import axis from "../Assets/Images/axis.svg";
import exclamination from "../Assets/Images/exclamation.svg";
import uparrows from "../Assets/Images/uparrows.svg";
import flow from "../Assets/Images/flow.svg";
import bitcoinImg from "../Assets/Images/bitcoin.svg";
import eth from "../Assets/Images/eth.svg";
import web from "../Assets/Images/web.svg";
import graphImg from "../Assets/Images/graphImg.svg";
import doc from "../Assets/Images/doc.svg";
import downarrows from "../Assets/Images/downarrows.svg";
import ToggleIcon from "../Assets/Images/ToggleIcon.svg";
import rightarrow from "../Assets/Images/rightarrow.svg";
import depositBtc from "../Assets/Images/kazixbtc.svg";
import Password from "../Assets/Images/password.svg";
import verified from "../Assets/Images/verified.svg";
import mobile from "../Assets/Images/mobile.svg";
import blueVerified from "../Assets/Images/blue-verified.svg";
import cosmoslogo from "../Assets/Images/cosmos-atom-logo.svg";
import confirm from "../Assets/Images/confirmation.svg";
import dollers from "../Assets/Images/dollers.svg";
import notifications from "../Assets/Images/notifications.svg";
import copy from "../Assets/Images/copy.svg";
import searchIcon from "../Assets/Images/SearchIcon.svg";
import greenIcon from "../Assets/Images/greenicon.svg";
import plateform from "../Assets/Images/platefomimg.png";
// import user from "../../redux/selector/user"
import search from "../Assets/Images/search.svg";
import mail from "../Assets/Images/mail.svg";
import openImg from "../Assets/Images/open.svg";
import feesImg from "../Assets/Images/fees.svg";
import buidCrypto from "../Assets/Images/buildCrypto.svg";
import tradeAnywere from "../Assets/Images/tradeAnywere.svg";
import safeWallet from "../Assets/Images/safewallet.svg";
import easySignup from "../Assets/Images/easySignup.svg";
import insta from "../Assets/Images/insta.svg";
import fb from "../Assets/Images/fb.svg";
import telegram from "../Assets/Images/telegram.svg";
import twitter from "../Assets/Images/twitter.svg";
import linkedIn from "../Assets/Images/linkin.svg";
import filledImg from "../Assets/Images/filled.svg";
import trustMobileNew from "../Assets/Images/trustMobilenew.png";
import selectAddress from "../Assets/Images/selectAddress.svg";
import AddressIcon from "../Assets/Images/AddressIcon.svg";
import copyIcon from "../Assets/Images/copyicon.svg";
import DeleteIcon from "../Assets/Images/DeleteIcon.svg";
import ruleImg from "../Assets/Images/rules.svg";
import redemptionImg from "../Assets/Images/redemptioicon.svg";
import star from "../Assets/Images/Star.svg";
import review from "../Assets/Images/Review.svg";
import download from "../Assets/Images/doenload.svg";
import dlt from "../Assets/Images/dltIcon.svg";
import spotImg from "../Assets/Images/spot.svg";
import fundingImg from "../Assets/Images/funding.svg";
import submissionImg from "../Assets/Images/submission.svg";
import Retail from "../Assets/Images/Retail.svg";
import Corporate from "../Assets/Images/Corporate.svg";
import ArrowRightGreen from "../Assets/Images/rightArrowGreen.svg";
import BankDesposite from "../Assets/Images/bankDesposite.svg";
import CryptoDeposite from "../Assets/Images/cryptoDeposite.svg";
import MNT from "../Assets/Images/MNT.svg";
import copyGreen from "../Assets/Images/copyGreen.svg";
import pdftran from "../Assets/Images/pdfWhite.png";
import Launchproject from "../Assets/Images/launchprojectImg.svg";
import playstore from "../Assets/Images/playstor.svg";
import appleStore from "../Assets/Images/applestore.svg";

import playicon from "../Assets/Images/play-icon.svg"

export const StoreImages = {
  spendinglimit: require("../Assets/Images/spendinglimit.png"),
  whitepaper: require("../Assets/Images/whitepaper.png"),
  networkadd: require("../Assets/Images/networkadd.png"),
  usingnetwork: require("../Assets/Images/usingnetwork.png"),
  factcrisis: require("../Assets/Images/crisis.png"),
  fraud: require("../Assets/Images/fraud.png"),
  tradecomb: require("../Assets/Images/usdtcomb.png"),
  ecotera: require("../Assets/Images/ecotera.png"),
  sponse: require("../Assets/Images/sponse.png"),
  WillStaple: require("../Assets/Images/newCardImg.png"),
  coindistributionImg: require("../Assets/Images/coindisimg.png"),
  tokencenter: require("../Assets/Images/tokencenterbg.png"),
  tokens: require("../Assets/Images/tokens.png"),

  spendinglimit:require("../Assets/Images/spendinglimit.png"),
  whitepaper:require("../Assets/Images/whitepaper.png"),
  networkadd:require("../Assets/Images/networkadd.png"),
  usingnetwork:require("../Assets/Images/usingnetwork.png"),
  factcrisis:require("../Assets/Images/crisis.png"),
  fraud:require("../Assets/Images/fraud.png"),
  tradecomb:require("../Assets/Images/usdtcomb.png"),
  ecotera:require("../Assets/Images/ecotera.png"),
  sponse:require("../Assets/Images/sponse.png"),
  WillStaple:require("../Assets/Images/newCardImg.png"),
  coindistributionImg:require("../Assets/Images/coindisimg.png"),
  coindistributionImgMn:require("../Assets/Images/coindisimgMn.png"),
  tokencenter:require("../Assets/Images/tokencenterbg.png"),
  tokens:require("../Assets/Images/tokens.png"),
  user: require("../Assets/Images/user.png"),
  ListingCoin: require("../Assets/Images/iconlistedcoin.png"),
  daynight: require("../Assets/Images/daynight.png"),
  tribeImg: require("../Assets/Images/rally.png"),
  pricechart: require("../Assets/Images/grapghimg.png"),
  scanner: require("../Assets/Images/scanner.png"),
  authentication: require("../Assets/Images/authentication.png"),
  barCode: require("../Assets/Images/barCode.png"),
  fuzzy: require("../Assets/Images/mobile.png"),
  robot: require("../Assets/Images/robbot.png"),
  trustMobile: require("../Assets/Images/trustMobile.png"),
  copyICONPNG: require("../Assets/Images/copyICON.png"),
  engine: require("../Assets/Images/engine.png"),
  secure: require("../Assets/Images/secure.png"),
  liquidity: require("../Assets/Images/liquidity.png"),
  wallet: require("../Assets/Images/wallet.png"),
  trading: require("../Assets/Images/trading.png"),
  payment: require("../Assets/Images/payment.png"),
  BannerImg: require("../Assets/Images/banner-img-updated.png"),
  LandingLogo: require("../Assets/Images/inkagent-logo.png"),
  SignImg: require("../Assets/Images/sign-img.png"),
  SignInMobile: require("../Assets/Images/signInMobile.png"),
  InteractImg: require("../Assets/Images/interact-img2.png"),
  InteractImg2: require("../Assets/Images/interact-img3.png"),
  Mobile: require("../Assets/Images/mobile-updated.png"),
  FeatureImg: require("../Assets/Images/feature_img.png"),
  MacMockUp: require("../Assets/Images/mac-mockup.png"),
  InkAgentLogo: require("../Assets/Images/inkagent-logo.png"),

  VedioMP4: require("../Assets/Images/video.mp4"),
  VedioPoster: require("../Assets/Images/video-poster.jpg"),

  ClientProile: require("../Assets/Images/client-profile.png"),


  swapping: require("../Assets/Images/swapping.png"),
  coin: require("../Assets/Images/coin.png"),
  cardExchange: require("../Assets/Images/card-Exchange.png"),
  aiTrading: require("../Assets/Images/Ai-trading.png"),
  staking: require("../Assets/Images/staking.png"),
  mobileApp: require("../Assets/Images/mobileApp.png"),
  barcode: require("../Assets/Images/barCode.png"),
  groupMobile: require("../Assets/Images/groupmobile.png"),
  QRcode: require("../Assets/Images/QrCode.png"),
  staple: require("../Assets/Images/staples.png"),
  WillStaples: require("../Assets/Images/newCardImg.png"),
  spotImg: spotImg,
  fundingImg: fundingImg,
  logo: logo,
  confirm: confirm,
  PlayIcon: playicon,
  dollers: dollers,
  redemptionImg: redemptionImg,
  greenIcon: greenIcon,
  cosmoslogo: cosmoslogo,
  filledImg: filledImg,
  feesImg: feesImg,
  openImg: openImg,
  copyIcon: copyIcon,
  home: home,
  rightarrow: rightarrow,
  bitCoin: bitCoin,
  graphImg: graphImg,
  uparrows: uparrows,
  downarrows: downarrows,
  notification: notification,
  bitcoinImg: bitcoinImg,
  depositBtc: depositBtc,
  breadcrumb: breadcrumb,
  ruleImg: ruleImg,
  etheImg: etheImg,
  application: application,
  downarrowDark: downarrowDark,
  eth: eth,
  arrow: arrow,
  exchange: exchange,
  history: history,
  masterCard: masterCard,
  backArrow: backArrow,
  binance: binance,
  tron: tron,
  axis: axis,
  exclamination: exclamination,
  web: web,
  doc: doc,
  flow: flow,
  ToggleIcon: ToggleIcon,
  Password: Password,
  verified: verified,
  mobile: mobile,
  blueVerified: blueVerified,
  notifications: notifications,
  copy: copy,
  searchIcon: searchIcon,
  search: search,
  mail: mail,
  Retail: Retail,
  Corporate: Corporate,
  buidCrypto: buidCrypto,
  tradeAnywere: tradeAnywere,
  safeWallet: safeWallet,
  easySignup: easySignup,
  insta: insta,
  fb: fb,
  telegram: telegram,
  twitter: twitter,
  linkedIn: linkedIn,
  trustMobileNew: trustMobileNew,
  selectAddress: selectAddress,
  AddressIcon: AddressIcon,
  DeleteIcon: DeleteIcon,
  star: star,
  review: review,
  download: download,
  dlt: dlt,
  submissionImg: submissionImg,
  ArrowRightGreen: ArrowRightGreen,
  BankDesposite: BankDesposite,
  CryptoDeposite: CryptoDeposite,
  MNT: MNT,
  copyGreen: copyGreen,
  plateform: plateform,
  Launchproject: Launchproject,
  playstore: playstore,
  pdftran: pdftran,
  appleStore: appleStore,
};
